import React from 'react';
import PropTypes from 'prop-types';
import WithTooltip from 'relements/build/esm/overlays/withTooltip';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';

import { confirmDeployBot, deployBot } from '@src/actions/BotActions';
import { getAuditHeaders } from '@src/utils/AuditLogs';

import styles from './TrainButton.scss';

const TRAIN_STATUS = {
  STARTED: 'training_started',
  NEEDS_TRAINING: 'needs_training',
};

export default class TrainButton extends React.Component {
  render() {
    const trainDisabled = this.props.status[TRAIN_STATUS.STARTED];
    const trainNeeded = this.props.status[TRAIN_STATUS.NEEDS_TRAINING];
    const trainTooltip = this._getTooltip();
    const trainingNeededClassName = trainNeeded ? styles.trainNeeded : '';
    return (
      <WithTooltip
        tooltip={trainTooltip}
        position="BOTTOM"
        className={`${styles.trainButton} ${trainingNeededClassName}`}
      >
        <Button
          onClick={this._startTraining}
          size="big"
          disabled={trainDisabled}
          type={!trainDisabled ? Button.TYPES.OUTLINE : undefined}
        >
          {trainNeeded && !trainDisabled ? (
            <Icon className={styles.trainNeededIcon} src="error_response" />
          ) : null}
          Train
        </Button>
      </WithTooltip>
    );
  }

  _getTooltip = () => {
    const trainDisabled = this.props.status[TRAIN_STATUS.STARTED];
    const trainNeeded = this.props.status[TRAIN_STATUS.NEEDS_TRAINING];

    if (trainDisabled) return 'Training in Progress';
    if (trainNeeded) return 'Please train your bot';
    return '';
  };

  _startTraining = () => {
    const domainName = this.props.domain.title.toLowerCase();
    const domainId = this.props.domain.id;
    const headers = getAuditHeaders({
      domain: this.props.domain,
      eventName: 'train_bot',
    });

    confirmDeployBot(domainName, () => {
      deployBot(domainName, headers, domainId);
      this.props.onStart();
    });
  };
}

TrainButton.propTypes = {
  onStart: PropTypes.func,
  status: {
    [TRAIN_STATUS.STARTED]: PropTypes.bool,
    [TRAIN_STATUS.TRAIN_NEEDED]: PropTypes.bool,
  },
  domain: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
};

TrainButton.defaultProps = {
  onStart: () => {},
  status: {
    [TRAIN_STATUS.STARTED]: false,
    [TRAIN_STATUS.TRAIN_NEEDED]: false,
  },
};
